exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".resource-pool-content .vcenter-section .leftIcon {\n  float: left;\n  margin: 0 10px; }\n\n.resource-pool-content .vcenter-section .details {\n  float: left; }\n\n.resource-pool-content .rp-dps-section {\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n  margin: 15px 0 0 0;\n  padding: 10px 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/manage/resource-pool/resource-pool-details-vc.scss
// module id = sM/M
// module chunks = 0